//@ts-check
import useChidDetails from "../../../pages/Kids/useChildDetails";
import React from "react";
import characterStore from "../../../store/CharactersStore";
import { STEP } from "./constant";
import childIllustration from "../../../assets/child-illustration.webp";
import { CircularProgress } from "@mui/material";

export const HumanList = () => {
  const { kidsData, loading } = useChidDetails();
  const [setActiveView, setSelectedKidForCharacter] = characterStore(
    (state) => [state.setActiveView, state.setSelectedKidForCharacter]
  );
  if (loading) {
    return (
      <div className="min-h-[90%] flex-col flex justify-center items-center ">
        <CircularProgress />
        <h2>Loading..</h2>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 md:grid-cols-charactercircle place-items-center gap-x-10 gap-y-6 justify-center items-center cursor-pointer max-h-[90%] overflow-y-auto">
      {kidsData?.map((kid) => (
        <div
          onClick={() => {
            setSelectedKidForCharacter(kid);
            setActiveView(STEP.CHARACTER_FROM_HUMAN);
          }}
          key={kid.id}
          className="group relative drop-shadow-lg w-[8rem] h-[8rem] md:w-[12rem] md:h-[12rem] overflow-hidden flex justify-center rounded-full"
        >
          {kid.image_urls[0] ? (
            <img
              className="group-hover:scale-110 transition ease-in-out duration-300 w-full h-full object-cover"
              src={kid.image_urls[0]}
              alt={kid.name}
            />
          ) : (
            <img
              className="group-hover:scale-110 transition ease-in-out duration-300 w-full h-full object-cover"
              src={childIllustration}
              alt="child illustration"
            />
          )}
          <div className="w-full h-full absolute hover:bg-[#1c5f53] hover:bg-opacity-30">
            <div className="hidden group-hover:flex justify-center items-center h-full">
              <p className="text-white text-lg font-bold shadow-teal-600 drop-shadow-md">
                {kid.name}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
